import { useEffect } from "react";

function upsertMeta(selector, attrs) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
    document.head.appendChild(el);
    return el;
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
  return el;
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
  return el;
}

export default function useSeo({ title, description, keywords, image, path }) {
  useEffect(() => {
    const siteName = "Ess Bee Heaters Pvt. Ltd.";
    const fullTitle = title ? `${title} | ${siteName}` : siteName;
    const url = `${window.location.origin}${path || window.location.pathname}`;
    const img = image || `${window.location.origin}/favicon.svg`;

    document.title = fullTitle;
    upsertMeta('meta[name="description"]', { name: "description", content: description || "" });
    if (keywords) upsertMeta('meta[name="keywords"]', { name: "keywords", content: keywords });

    // Open Graph
    upsertMeta('meta[property="og:title"]', { property: "og:title", content: fullTitle });
    upsertMeta('meta[property="og:description"]', { property: "og:description", content: description || "" });
    upsertMeta('meta[property="og:type"]', { property: "og:type", content: "website" });
    upsertMeta('meta[property="og:site_name"]', { property: "og:site_name", content: siteName });
    upsertMeta('meta[property="og:url"]', { property: "og:url", content: url });
    upsertMeta('meta[property="og:image"]', { property: "og:image", content: img });

    // Twitter
    upsertMeta('meta[name="twitter:card"]', { name: "twitter:card", content: "summary_large_image" });
    upsertMeta('meta[name="twitter:title"]', { name: "twitter:title", content: fullTitle });
    upsertMeta('meta[name="twitter:description"]', { name: "twitter:description", content: description || "" });
    upsertMeta('meta[name="twitter:image"]', { name: "twitter:image", content: img });

    // Canonical
    upsertLink("canonical", url);
  }, [title, description, keywords, image, path]);
}
